"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../../constants");
var _icons = require("../../icons");
var _tooltipContent = require("../tooltip-content.css");
const FeedbackTooltipContent = ({
  url,
  onURLOpened
}) => {
  const openFeedbackPage = () => {
    onURLOpened === null || onURLOpened === void 0 ? void 0 : onURLOpened();
    window.open(url, `blank`, `noreferrer`);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: `5px`
    }
  }, _constants.messages.howAreWeDoing), /*#__PURE__*/_react.default.createElement("button", {
    onClick: openFeedbackPage,
    className: _tooltipContent.linkWrapperStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tooltipContent.linkTextStyle
  }, _constants.messages.shareFeedback), _icons.logsIcon));
};
var _default = FeedbackTooltipContent;
exports.default = _default;